export default {
  vendorBudget: {
    title: "Debug Dienstleister-Budget",
    buttons: {
      testIntegration: "Integration Testen",
      testing: "Test läuft...",
      clear: "Löschen",
    },
    errors: {
      noUserOrEvent: "❌ Kein Benutzer oder Ereignis ausgewählt",
      noUser: "❌ Kein Benutzer angemeldet",
      noEvent: "❌ Kein Ereignis ausgewählt",
      testError: "❌ Fehler beim Test",
    },
    messages: {
      startTest: "🧪 Vollständiger Test der Dienstleister-Budget-Integration...",
      initialState: "📊 Anfangszustand der Ausgaben...",
      initialFound: "Anfang: {{count}} Ausgaben gefunden",
      creatingVendor: "👨‍💼 Erstelle einen beauftragten Dienstleister mit Preis...",
      vendorData: "Dienstleister-Daten: {{data}}",
      vendorCreated: "✅ Dienstleister erstellt mit ID: {{id}}",
      waitingExpenses: "⏳ Warte auf Erstellung der Ausgaben...",
      checkingExpenses: "📊 Überprüfe Ausgaben nach Dienstleister-Erstellung...",
      afterCreation: "Nach Erstellung: {{count}} Ausgaben gefunden",
      vendorExpenses: "Dienstleister-Ausgaben: {{count}}",
      expenseDetail: "{{index}}. {{title}}: {{amount}}€ (bezahlt: {{paid}})",
      checkingIds: "🔍 Überprüfe Ausgaben-IDs im Dienstleister...",
      vendorFound: "Dienstleister gefunden: {{name}}",
      expenseId: "Ausgaben-ID: {{id}}",
      depositExpenseId: "Anzahlungs-ID: {{id}}",
      notDefined: "nicht definiert",
      vendorNotFound: "❌ Dienstleister nach Erstellung nicht gefunden",
      cleanup: "🧹 Bereinigung: Lösche Test-Dienstleister...",
      vendorDeleted: "✅ Test-Dienstleister gelöscht",
      finalCheck: "📊 Finale Überprüfung der Ausgaben...",
      finalCount: "Final: {{count}} Ausgaben gefunden",
      cleanupSuccess: "✅ Bereinigung erfolgreich: Alle Test-Ausgaben wurden gelöscht",
      cleanupWarning: "⚠️ Warnung: Einige Test-Ausgaben könnten noch bestehen",
    },
    noLogs: "Noch keine Logs...",
  },
  contactsApi: {
    title: "Contact Picker API Test",
    browser: "Browser",
    https: "HTTPS",
    apiStatus: "Contact Picker API",
    enabled: "Aktiviert",
    disabled: "Deaktiviert",
    supported: "Unterstützt",
    notSupported: "Nicht unterstützt",
    technicalDetails: "Technische Details",
    userAgent: "User Agent",
    platform: "Platform",
    language: "Sprache",
    cookiesEnabled: "Cookies aktiviert",
    yes: "Ja",
    no: "Nein",
    testButton: "Kontakt-Zugang testen",
    testing: "Test läuft...",
    error: "Fehler",
    contactsRetrieved: "Kontakte abgerufen ({{count}})",
    noName: "Ohne Name",
    recommendations: "Empfehlungen",
    recommendation1: "• Verwenden Sie Chrome auf Android oder Safari auf iOS für beste Ergebnisse",
    recommendation2: "• Stellen Sie sicher, dass die Website HTTPS verwendet",
    recommendation3: "• Erlauben Sie den Zugriff auf Kontakte wenn gefragt",
    recommendation4: "• Diese API funktioniert in den meisten Fällen nur auf mobilen Geräten",
    errors: {
      notSupported: "Die Contact Picker API wird auf diesem Browser nicht unterstützt",
      unknown: "Unbekannter Fehler beim Zugriff auf Kontakte",
    },
    browserDetection: {
      chromeMobile: "Chrome Mobile",
      safariMobile: "Safari Mobile",
      chromeDesktop: "Chrome Desktop",
      safariDesktop: "Safari Desktop",
      firefox: "Firefox",
      edge: "Edge",
      unknown: "Unbekannter Browser",
    },
  },
}; 